import { Injectable } from '@angular/core';
import { ApiInterface } from './api-interface';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

export interface AtividadeBackend { enum: string; nome: string; id: number; }

@Injectable({
  providedIn: 'root',
})
export class AtividadeEmpresaService implements ApiInterface {

  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<T> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<T>(patch);
  }
  getById<T>(url: string): Observable<T> { throw new Error('Method not implemented.'); }
  post<T>(url: string, data: any): Observable<T> { throw new Error('Method not implemented.'); }
  put<T>(url: string, data: any): Observable<T> { throw new Error('Method not implemented.'); }
  delete<T>(url: string): Observable<T> { throw new Error('Method not implemented.'); }

  // Busca a lista de atividades
  listarAtividades(): Observable<AtividadeBackend[] | { content: AtividadeBackend[] }> {
    return this.get<AtividadeBackend[] | { content: AtividadeBackend[] }>('/enums/atividadeDaEmpresa');
  }
}
